// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"833":"b16986d0","849":"4d143a43"}[chunkId] + ".css";
};